export default {
  field__account_number: '账号（IBAN）',
  field__document_type: '文件类型',
  field__document_id: '文件ID',
  field__account_holder: '账户持有人姓名',
  field__bank_name: '银行名称',
  field__bank_code: '银行代码',
  field__bank_ifsc_code: '银行 IFSC 代码(印度)',
  field__account_holder_address: '账户持有人地址',
  field__bank_address: '银行地址',
  field__bic: 'BIC',
  field__purpose_of_payment: '付款用途',
  field__pay_id: 'PayID',
  field__card_last_four_digits: '卡号后四位',
  field__invoice_receipt_number: '账单收据编号',
  field__rif: 'RIF',
  field__phone: '电话',
  field__beneficiary: '受益人',
  field__cbu: 'CBU/CVU',
  field__alias: '别名',
};
